import React from 'react';

export interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  onClick?: () => void;
}

export const Card = ({ children, className = '', title, onClick }: CardProps) => {
  const hasCustomBg = className.includes('bg-');
  const baseClasses = hasCustomBg
    ? 'rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md hover:border-gray-200 transition-all duration-200'
    : 'bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md hover:border-gray-200 transition-all duration-200';

  return (
    <div className={`${baseClasses} ${className}`} onClick={onClick}>
      {title && (
        <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-3 border-b border-gray-100">
          {title}
        </h3>
      )}
      {children}
    </div>
  );
};

